/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { IPersonaProps, Persona } from "@fluentui/react";
import { observer } from "mobx-react";
import * as React from "react";

import { IUserPersonaProps } from "./IUserPersonaProps";
import { updateTextProps } from "./UserPersona.mappers";
import { getClassNames } from "./userPersonaWithoutPicture.styles";
import { useCrossLocationTeamName } from "../shift/shiftDetails/CrossLocationTeamName.mappers";

const styles = getClassNames();

export const UserPersonaWithoutPicture: React.FC<IUserPersonaProps> = observer(props => {
    const { crossLocationTeamId, ...remainingProps } = props;
    const coinProps = { className: styles.icon };

    // TODO (CLM): Consider how to show team name when username goes over two lines.
    let teamName = useCrossLocationTeamName({ crossLocationTeamId });
    const personaProps = updateTextProps(remainingProps, teamName);
    const { text, secondaryText, className } = personaProps;

    return (
        <Persona
            className={className}
            text={text}
            secondaryText={secondaryText}
            coinProps={coinProps}
            onRenderPrimaryText={_onRenderPrimaryText}
        />
    );
});

/**
 * Custom styling of display name (primaryText) to be on two lines.
 * @param props The persona properties.
 * @returns The JSX element.
 */
function _onRenderPrimaryText(props: IPersonaProps): JSX.Element {
    return <div className={styles.primaryText}>{props.text}</div>;
}
